import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import SmsSetting from '../entities/smsSetting'

import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'


interface SmsSettingState extends ListState<SmsSetting>{
    smsSetting:SmsSetting
    editSmsSetting:SmsSetting

}

class SmsSettingMutations extends ListMutations<SmsSetting>{

}

class SmsSettingModule extends ListModule<SmsSettingState,any,SmsSetting>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<SmsSetting>(),
        loading:false,
        editSmsSetting:new SmsSetting(),
        selectSmsSetting:new SmsSetting(),
      
    
    
    }
    actions={

        async selectSmsSetting(context:ActionContext<SmsSettingState,any>,payload:any){
            context.state.editSmsSetting=payload.data;
        },
     
        async saveSmsSetting(context:ActionContext<SmsSettingState,any>,payload:any){
         
        
            let reponse=await Ajax.post('/api/services/app/Setting/SaveSmsSetting',payload.data);
          
            let page=reponse.data.result as PageResult<SmsSetting>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async updateSmsSetting(context:ActionContext<SmsSettingState,any>,payload:any){
         
        
            let reponse=await Ajax.put('/api/services/app/Setting/UpdateSmsSetting',payload.data);
          
            let page=reponse.data.result as PageResult<SmsSetting>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getSmsSettings(context:ActionContext<SmsSettingState,any>,payload:any){
          
           // context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Setting/GetSmsSettings',payload.data);
          
           // context.state.loading=false;
            let page=reponse.data.result as PageResult<SmsSetting>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
       
     
   
 
    };
    mutations={
        setCurrentPage(state:SmsSettingState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:SmsSettingState,pagesize:number){
            state.pageSize=pagesize;
        },
    }
}
const smsSettingModule=new SmsSettingModule();
export default smsSettingModule;